import sendRequest from "@/libs/sendRequest"

export const conquests = {
    namespaced: true,
    state: {
        conquest: null,
        conquests: null,
        total_pages: 1,
        error: null,
        fake_list: {
            success: true,
            data: [
                {
                    id: 1,
                    store_name: "El Gym",
                    contact_name: 'Cristopher Lopez',
                    contact_phone: '3221267111',
                    asessor: 2024,
                    assesor_name: 'Jorge Luis Pérez',
                    conquest_status: 'requested',
                    status: 1,
                    creation: '2025-09-10T18:12:04.340Z',
                },
                {
                    id: 2,
                    store_name: "San Juan",
                    contact_name: 'María Torres',
                    contact_phone: '5552317890',
                    asessor: 2025,
                    assesor_name: 'Carla Mendoza',
                    conquest_status: 'requested',
                    status: 0,
                    creation: '2025-09-11T09:25:44.123Z',
                },
                {
                    id: 3,
                    store_name: "Super Ahorro",
                    contact_name: 'Luis Hernández',
                    contact_phone: '5534129987',
                    asessor: 2026,
                    assesor_name: 'Pedro Castillo',
                    conquest_status: 'approved',
                    status: 1,
                    creation: '2025-09-11T11:02:55.845Z',
                },
                {
                    id: 4,
                    store_name: "La Central",
                    contact_name: 'Ana Gómez',
                    contact_phone: '5578142365',
                    asessor: 2027,
                    assesor_name: 'Laura Rivera',
                    conquest_status: 'rejected',
                    status: 0,
                    creation: '2025-09-12T14:42:11.672Z',
                },
                {
                    id: 5,
                    store_name: "El Paso",
                    contact_name: 'Javier Morales',
                    contact_phone: '5519283746',
                    asessor: 2028,
                    assesor_name: 'Sofía Ramírez',
                    conquest_status: 'requested',
                    status: 1,
                    creation: '2025-09-12T16:03:22.901Z',
                },
                {
                    id: 6,
                    store_name: "Mini Súper Lupita",
                    contact_name: 'Carmen López',
                    contact_phone: '5548129367',
                    asessor: 2029,
                    assesor_name: 'Héctor Jiménez',
                    conquest_status: 'approved',
                    status: 1,
                    creation: '2025-09-13T08:15:44.232Z',
                },
                {
                    id: 7,
                    store_name: "El Martillo",
                    contact_name: 'Andrés Martínez',
                    contact_phone: '5589234765',
                    asessor: 2030,
                    assesor_name: 'Raúl Fernández',
                    conquest_status: 'requested',
                    status: 0,
                    creation: '2025-09-13T12:19:07.499Z',
                },
                {
                    id: 8,
                    store_name: "La Esquina",
                    contact_name: 'Paola Vázquez',
                    contact_phone: '5567123456',
                    asessor: 2031,
                    assesor_name: 'Julio Chávez',
                    conquest_status: 'requested',
                    status: 1,
                    creation: '2025-09-14T10:21:34.612Z',
                },
                {
                    id: 9,
                    store_name: "Estrella",
                    contact_name: 'Ricardo Soto',
                    contact_phone: '5598234711',
                    asessor: 2032,
                    assesor_name: 'Daniela Ortega',
                    conquest_status: 'approved',
                    status: 1,
                    creation: '2025-09-14T13:56:18.777Z',
                },
                {
                    id: 10,
                    store_name: "Las Flores",
                    contact_name: 'Gabriela Flores',
                    contact_phone: '5523789410',
                    asessor: 2033,
                    assesor_name: 'Fernando Ruiz',
                    conquest_status: 'rejected',
                    status: 1,
                    creation: '2025-09-15T09:48:29.111Z',
                },
            ]
        }
    },
    getters: {
        getConquest: (state) => (state.conquest),
        getConquests: (state) => (state.conquests),
        getTotalPages: (state) => (state.total_pages),
        getError: (state) => (state.error)
    },
    mutations: {
        setConquest: (state, payload) => state.conquest = payload,
        setConquests: (state, payload) => state.conquests = payload,
        setTotalPages: (state, payload) => state.total_pages = payload,
        setError: (state, payload) => state.error = payload
    },
    actions: {
        list: async({state, commit, dispatch, rootGetters }, query) => {
            console.log(query)
            dispatch('showLoading', null, { root: true })
            const custom_headers = rootGetters.getHeaders
            // const response = await sendRequest('administrator/conquests/list', 'GET', null, null, null, custom_headers)
            const response = state.fake_list
            await new Promise(resolve => setTimeout(resolve, 1000));

            if(response.success && response.data) {
                commit('setConquests', response.data)
                dispatch('hiddenLoading', null, { root: true })
                console.log(state.conquests)
                // if(query.paginate) {
                //     commit('setTotalPages', response.data.pagination.totalPages)
                // }
            }
            else if(!response.success && response.errors) {
                commit('setError', true)
                dispatch('hiddenLoading', null, { root: true })
                dispatch('showError', errorHandling('clients', response.errors), { root: true })
            }
            else if(!response.success && !response.errors) {
                dispatch('lostConection', null, { root: true })
            }
        },
        view: async({ state, commit, rootGetters }, query) => {
            const custom_headers = rootGetters.getHeaders
            // const response = await sendRequest('administrator/conquests/view', 'GET', null, null, query, custom_headers)
            let item = state.fake_list.data.find(item => item.id === query.id)
            const response = {
                "success": true,
                "data": item
            }
            console.log(response, 'response')

            if(response.success && response.data) {
                commit('setConquest', response.data ?? null)
            }
            else if(!response.success && response.errors) {}
        },
        add: async({ commit, rootGetters }, body) => {
            const custom_headers = rootGetters.getHeaders
            // const response = await sendRequest('administrator/conquests/add', 'POST', null, body, null, custom_headers)

            if(response.success && response.data) {
                dispatch('showAlert', 'Conquista guardada con éxito', { root: true })
            }
            else if(!response.success && response.errors) {
                commit('setError', true)
                let messages = []

                for(let error in response.errors) {
                    switch(response.errors[error].code) {
                        case 'error_empty_values':
                            messages.push('Error: Los valores no han sido ingresados')
                            break;
                        default:
                            messages.push('Un error ha ocurrido intente más tarde')
                            return;
                    }
                }

                dispatch('showError', messages, { root: true })
            }
            else if(response.success && !response.data) {
                dispatch('showError', 'Ha ocurrido un error de conexión intente más tarde', { root: true })
            }
        },
        update: async({ commit, rootGetters }, body) => {
            const custom_headers = rootGetters.getHeaders
            const response = await sendRequest('administrator/conquests/update', 'PUT', null, body, null, custom_headers)

            if(response.success && response.data) {
                dispatch('showAlert', 'Conquista actualizada con éxito', { root: true })
            }
            else if(!response.success && response.errors) {
                commit('setError', true)
                let messages = []

                for(let error in response.errors) {
                    switch(response.errors[error].code) {
                        case 'error_empty_values':
                            messages.push('Error: Los valores no han sido ingresados')
                            break;
                        default:
                            messages.push('Un error ha ocurrido intente más tarde')
                            return;
                    }
                }

                dispatch('showError', messages, { root: true })
            }
            else if(response.success && !response.data) {
                dispatch('showError', 'Ha ocurrido un error de conexión intente más tarde', { root: true })
            }
        },
        inactive: async({ commit, rootGetters }, id) => {
            const custom_headers = rootGetters.getHeaders
            const response = await sendRequest('administrator/banners/active', 'PUT', null, null, { id: id}, custom_headers)

            if(response.success && response.data) {
                dispatch('showAlert', 'Conquista borrada con éxito', { root: true })
            }
            else if(!response.success && response.errors) {
                commit('setError', true)
                dispatch('showError', 'Un error ha ocurrido intente más tarde', { root: true })
            }
            else if(response.success && response.data) {
                dispatch('showError', 'Ha ocurrido un error de conexión intente más tarde', { root: true })
            }
        }
    }
}